import type { Problem, ProblemId } from '@/types';
import { conditionalProblems } from './sql/conditional';
import { joinsProblems } from './sql/joins';
import { cteProblems } from './sql/cte';
import { windowProblems } from './sql/window';
import { datetimeProblems } from './sql/datetime';
import { funnelProblems } from './sql/funnel';
import { retentionProblems } from './sql/retention';
import { revenueProblems } from './sql/revenue';
import { refundsProblems } from './sql/refunds';
import { recoveryProblems } from './sql/recovery';
import { anomalyProblems } from './sql/anomaly';
import { abProblems } from './sql/ab';
import { logicProblems } from './logic';
import { pythonProblems } from './python';
import { productProblems } from './product';
import { experimentProblems } from './experiment';
import { objectProblems } from './object';

export { LADDERS } from './ladders';

/** All gym problems, in ladder order. Add a category file's array to this list. */
export const PROBLEMS: Problem[] = [...conditionalProblems, ...joinsProblems, ...cteProblems, ...windowProblems, ...datetimeProblems, ...funnelProblems, ...retentionProblems, ...revenueProblems, ...refundsProblems, ...recoveryProblems, ...anomalyProblems, ...abProblems, ...logicProblems, ...pythonProblems, ...productProblems, ...experimentProblems, ...objectProblems];

const BY_ID = new Map<ProblemId, Problem>(PROBLEMS.map((p) => [p.id, p]));
export function getProblem(id: ProblemId | null | undefined): Problem | undefined {
  return id ? BY_ID.get(id) : undefined;
}
